import { Module, MutationTree, ActionTree, GetterTree } from "vuex"
import { RootState } from "../../index"
import { PricingPlansState } from "@/store/pricing-plans/types"

export interface TariffState {
    supplierEnergyBuy: PricingPlansState["configList"][number] | null
    supplierEnergySell: PricingPlansState["configList"][number] | null
    distributorEnergy: PricingPlansState["configList"][number] | null
    distributorPower: PricingPlansState["configList"][number] | null
}

const state: TariffState = {
    supplierEnergyBuy: null,
    supplierEnergySell: null,
    distributorEnergy: null,
    distributorPower: null,
}

const mutations: MutationTree<TariffState> = {
    setSupplierEnergyBuy(state, tariff: PricingPlansState["configList"][number]) {
        state.supplierEnergyBuy = tariff
    },
    setSupplierEnergySell(state, tariff: PricingPlansState["configList"][number]) {
        state.supplierEnergySell = tariff
    },
    setDistributorEnergy(state, tariff: PricingPlansState["configList"][number]) {
        state.distributorEnergy = tariff
    },
    setDistributorPower(state, tariff: PricingPlansState["configList"][number]) {
        state.distributorPower = tariff
    },
}

const actions: ActionTree<TariffState, RootState> = {
    setSupplierEnergyBuy({ commit }, tariff: PricingPlansState["configList"][number]) {
        commit("setSupplierEnergyBuy", tariff)
    },
    setSupplierEnergySell({ commit }, tariff: PricingPlansState["configList"][number]) {
        commit("setSupplierEnergySell", tariff)
    },
    setDistributorEnergy({ commit }, tariff: PricingPlansState["configList"][number]) {
        commit("setDistributorEnergy", tariff)
    },
    setDistributorPower({ commit }, tariff: PricingPlansState["configList"][number]) {
        commit("setDistributorPower", tariff)
    },
    resetTariff({ commit }) {
        commit("setSupplierEnergyBuy", null)
        commit("setSupplierEnergySell", null)
        commit("setDistributorEnergy", null)
        commit("setDistributorPower", null)
    },
}

const getters: GetterTree<TariffState, RootState> = {
    supplierEnergyBuy: (state) => state.supplierEnergyBuy,
    supplierEnergySell: (state) => state.supplierEnergySell,
    distributorEnergy: (state) => state.distributorEnergy,
    distributorPower: (state) => state.distributorPower,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
} as Module<TariffState, RootState>
